import { USER_MANAGEMENT } from './const';
import { saveBillingSnapshot } from './billingSnapshot';

export const openStripeCustomerPortal = async (
  postData,
  returnPath = '/main/account',
  activePlan = null,
) => {
  saveBillingSnapshot(activePlan);
  const response = await postData(USER_MANAGEMENT.CUSTOMER_PORTAL, { returnPath });
  if (!response?.url) {
    throw new Error('Stripe portal URL was not returned.');
  }
  window.location.assign(response.url);
};
